/**
 * The hand the frame draws inside "Tap to start" [Figma · `Icon / Hub / tap`, the 20×20 instance inside the
 * `Tap to start` button on `Welcome (tap to start) — Desktop` · `— iPad` · `— Mobile`].
 *
 * Exported from the design file rather than redrawn or borrowed: the paths, the 1.5px stroke and the round
 * caps are the frame's own, at the frame's 20×20. The prototype draws a different hand at a different
 * weight; where the two disagree on how something LOOKS the frame decides [decision 0155].
 *
 * `currentColor`, not the frame's literal white, so the icon follows the button's label on every variant —
 * the frame only ever draws it on the filled action, and hard-coding white would make it invisible the day
 * somebody puts it on a secondary one.
 *
 * `aria-hidden`, because the button's accessible name is its label: a candidate using a screen reader hears
 * "Tap to start", and an icon that announced itself would say it twice.
 */
export function TapIcon() {
  return (
    <svg
      aria-hidden="true"
      className="shrink-0"
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
    >
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <path d="M7.5 9.16683V5.00016C7.5 4.55814 7.6756 4.13421 7.98816 3.82165C8.30072 3.50909 8.72464 3.3335 9.16667 3.3335C9.60869 3.3335 10.0326 3.50909 10.3452 3.82165C10.6577 4.13421 10.8333 4.55814 10.8333 5.00016V9.16683" />
        <path d="M10.8334 9.16683V7.50016C10.8334 7.05814 11.009 6.63421 11.3215 6.32165C11.6341 6.00909 12.058 5.8335 12.5 5.8335C12.9421 5.8335 13.366 6.00909 13.6786 6.32165C13.9911 6.63421 14.1667 7.05814 14.1667 7.50016V9.16683" />
        <path d="M14.1666 9.1665V8.33317C14.1666 7.89114 14.3422 7.46722 14.6548 7.15466C14.9673 6.8421 15.3913 6.6665 15.8333 6.6665C16.2753 6.6665 16.6992 6.8421 17.0118 7.15466C17.3244 7.46722 17.5 7.89114 17.5 8.33317V13.3332C17.5 14.4382 17.061 15.498 16.2796 16.2794C15.4982 17.0609 14.4384 17.4998 13.3333 17.4998H11.25C10.5528 17.4987 9.86707 17.3226 9.25559 16.9877C8.64411 16.6529 8.12643 16.1699 7.74996 15.5832L4.16663 12.0832C3.94561 11.7516 3.86535 11.3459 3.94349 10.9552C4.02163 10.5645 4.25177 10.2209 4.58329 9.99984C4.91481 9.77882 5.32055 9.69856 5.71125 9.7767C6.10195 9.85484 6.44561 10.085 6.66663 10.4165L7.49996 11.4165" />
      </g>
    </svg>
  );
}
